import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

const ACCOUNT_SERVICES = {
  deactivationInitiate: (otpChannel) =>
    CLIENT.post(
      ENDPOINTS.ACCOUNT.deactivationInitiate,
      undefined,
      otpChannel ? { params: { otpChannel } } : undefined
    ),

  deactivationConfirm: (payload) =>
    CLIENT.post(ENDPOINTS.ACCOUNT.deactivationConfirm, payload),
};

export default ACCOUNT_SERVICES;
